import { bool, func, number, object, string, oneOf, oneOfType, shape } from 'prop-types';
import { ERROR_TYPE } from '../../hooks/useValidation';
import { noop } from '../../util/functions';

export const propTypes = {
	className: string,
	overrideValidation: oneOf(Object.values(ERROR_TYPE)),
	onChange: func,
	onBlur: func,
	required: bool,
	pattern: string,
	maxLength: oneOfType([number, string]),
	minLength: oneOfType([number, string]),
	onValidityChange: func,
	label: string,
	info: string,
	value: string,
	onRef: oneOfType([func, object]),
	disableValidation: bool,
	requiredMessage: string,
	errorMessage: string,
	name: string,
	innerCss: shape({
		root: object,
		input: object
	})
};

export const defaultProps = {
	onValidityChange: noop,
	onRef: noop,
	onBlur: noop,
	onKeyDown: noop,
	disableValidation: true,
	innerCss: {}
};
